import React, { useState } from "react";
import CartBox from "./box";
import { useGlobalContext } from "context/global";

const CartBoxSelector = ({ activeBox, minBoxSize, onBoxClick }) => {
	const { translation, cartSettings } = useGlobalContext();
	const [hasError, setError] = useState(false);

	const boxes = cartSettings.boxes ?? [];

	if (!boxes.length || !activeBox) return null;

	return (
		<div className="relative pb-3.5 md:pb-5 border-b">
			<div className="w-full mt-2 bg-[#D9D9D966] rounded-6xl">
				{boxes.map(box =>
					<CartBox
						box={box} key={box._key}
						isActive={activeBox.size.value === box.size.value}
						isDisabled={box.size.value < minBoxSize}
						showError={() => setError(true)}
						hideError={() => setError(false)}
						handleClick={() => onBoxClick(box)}
					/>)}
			</div>
			{hasError &&
				<div className="disable-box-warning">
					<div><span>{translation.cart?.remove_products_for_downgrade}</span></div>
				</div>}
		</div>
	);
};

export default CartBoxSelector;